import { useRouteError } from 'react-router';

// Data routers catch render errors themselves; rethrow so the app-level ErrorBoundary shows its FallbackUI
export const RouteErrorBoundary = () => {
  throw useRouteError();
};
